// extracted by mini-css-extract-plugin
export var closeButton = "_76-0";